import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { HelpArticleDto, GET_HELP_ARTICLES_QUERY_KEY } from './useHelpArticles';

export type CreateHelpArticleInput = {
  title: string;
  slug: string;
  contentKey: string;
  excerpt?: string;
  content: string;
  language: string;
  status?: string;
  categoryId: string;
  coverImage?: string;
  sortOrder?: number;
};

export const useCreateHelpArticle = (onSuccess: (data: HelpArticleDto) => void) => {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateHelpArticleInput) =>
      client.fetchApi<HelpArticleDto, CreateHelpArticleInput>({ endpoint: 'help/admin/articles', method: 'POST', body: input }),
    onSuccess: (data) => {
      queryClient.invalidateQueries(GET_HELP_ARTICLES_QUERY_KEY);
      onSuccess(data);
    },
  });
};
